(() => {
  'use strict';

  const storageKey = 'uykke_campaign_attribution_v1';
  const attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  const cannabisPath = '/collections/cannabis-cultivation-processing';
  const wholesalePath = '/pages/wholesale';

  const cleanValue = (value) => String(value || '').trim().slice(0, 160);

  const readAttribution = (url) => {
    const values = {};
    attributionKeys.forEach((key) => {
      const value = cleanValue(url.searchParams.get(key));
      if (value) values[key] = value;
    });
    return values;
  };

  const readStoredAttribution = () => {
    try {
      const stored = JSON.parse(window.sessionStorage.getItem(storageKey) || '{}');
      return stored && typeof stored === 'object' ? stored : {};
    } catch (_error) {
      return {};
    }
  };

  const currentUrl = new URL(window.location.href);
  const currentAttribution = readAttribution(currentUrl);
  let attribution = { ...readStoredAttribution(), ...currentAttribution };

  if (Object.keys(currentAttribution).length > 0) {
    if (currentUrl.pathname === cannabisPath) {
      attribution.landing_path = cannabisPath;
      attribution.industry = 'cannabis_cultivation_processing';
    }
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(attribution));
    } catch (_error) {
      // Attribution remains available for the current page when storage is blocked.
    }
  }

  const eventAttribution = () => ({
    source: cleanValue(attribution.utm_source),
    medium: cleanValue(attribution.utm_medium),
    campaign: cleanValue(attribution.utm_campaign),
    content: cleanValue(attribution.utm_content),
    industry: cleanValue(attribution.industry),
    landing_path: cleanValue(attribution.landing_path),
  });

  const publish = (name, data = {}) => {
    if (!window.Shopify?.analytics?.publish) return;
    try {
      const result = window.Shopify.analytics.publish(`uykke:${name}`, {
        ...eventAttribution(),
        ...data,
      });
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch (_error) {
      // Analytics must never interrupt navigation or form submission.
    }
  };

  const addAttributionToLink = (link) => {
    if (!link || Object.keys(attribution).length === 0) return;
    const destination = new URL(link.href, window.location.origin);
    if (destination.origin !== window.location.origin) return;
    if (destination.pathname !== wholesalePath && !destination.pathname.startsWith('/products/')) return;

    attributionKeys.forEach((key) => {
      if (attribution[key] && !destination.searchParams.has(key)) {
        destination.searchParams.set(key, attribution[key]);
      }
    });
    link.href = destination.toString();
  };

  const sectionName = (element) => {
    const section = element.closest('section[id], header');
    if (!section) return 'page';
    return cleanValue(section.id || 'hero').replace(/[^a-zA-Z0-9_-]/g, '_');
  };

  const classifyCannabisLink = (link) => {
    const destination = new URL(link.href, window.location.origin);
    const pageSection = sectionName(link);

    if (destination.hostname.endsWith('amazon.com')) {
      const asinMatch = destination.pathname.match(/\/dp\/([A-Z0-9]{10})/i);
      return {
        name: 'cannabis_amazon_click',
        data: { page_section: pageSection, asin: cleanValue(asinMatch?.[1]).toUpperCase() },
      };
    }
    if (destination.origin === window.location.origin && destination.pathname.startsWith('/products/')) {
      return {
        name: 'cannabis_product_click',
        data: {
          page_section: pageSection,
          product_handle: cleanValue(destination.pathname.split('/products/')[1]),
          variant_id: cleanValue(destination.searchParams.get('variant')),
        },
      };
    }
    if (destination.origin === window.location.origin && destination.pathname === wholesalePath) {
      return { name: 'cannabis_wholesale_click', data: { page_section: pageSection } };
    }
    if (link.protocol === 'mailto:') {
      return { name: 'cannabis_email_intent', data: { page_section: pageSection } };
    }
    return null;
  };

  const classifyArticleLink = (link, container) => {
    const destination = new URL(link.href, window.location.origin);
    const articleSlug = cleanValue(container.getAttribute('data-uykke-article-products'));
    const pageSection = sectionName(link);

    if (destination.origin === window.location.origin && destination.pathname.startsWith('/products/')) {
      return {
        name: 'article_product_click',
        data: {
          article_slug: articleSlug,
          product_handle: cleanValue(destination.pathname.split('/products/')[1]),
          variant_id: cleanValue(destination.searchParams.get('variant')),
          page_section: pageSection,
        },
      };
    }
    if (destination.origin === window.location.origin && destination.pathname.startsWith('/collections/')) {
      return {
        name: 'article_collection_click',
        data: {
          article_slug: articleSlug,
          collection_handle: cleanValue(destination.pathname.split('/collections/')[1]),
          page_section: pageSection,
        },
      };
    }
    return null;
  };

  document.addEventListener('DOMContentLoaded', () => {
    const cannabisPage = document.querySelector('[data-uykke-industry="cannabis-cultivation-processing"]');
    if (cannabisPage) {
      cannabisPage.querySelectorAll('a[href]').forEach(addAttributionToLink);
      publish('cannabis_landing_view', { page_path: cannabisPath });
    }

    const articleProducts = document.querySelector('[data-uykke-article-products]');
    if (articleProducts) {
      articleProducts.querySelectorAll('a[href]').forEach(addAttributionToLink);
    }

    const wholesaleForm = document.getElementById('UYKKEWholesaleForm');
    if (wholesaleForm) {
      const isCannabis = attribution.industry === 'cannabis_cultivation_processing'
        || attribution.landing_path === cannabisPath
        || cleanValue(attribution.utm_campaign).toLowerCase().includes('cannabis');
      const fields = {
        'UYKKEInquirySource': isCannabis ? 'Cannabis industry landing' : 'UYKKE wholesale page',
        'UYKKEIndustry': isCannabis ? 'Cannabis cultivation and processing' : '',
        'UYKKELandingPage': cleanValue(attribution.landing_path),
        'UYKKEUtmSource': cleanValue(attribution.utm_source),
        'UYKKEUtmMedium': cleanValue(attribution.utm_medium),
        'UYKKEUtmCampaign': cleanValue(attribution.utm_campaign),
        'UYKKEUtmContent': cleanValue(attribution.utm_content),
      };
      Object.entries(fields).forEach(([id, value]) => {
        const input = document.getElementById(id);
        if (input) input.value = value;
      });
      publish('wholesale_form_view', {
        page_path: wholesalePath,
        inquiry_source: fields.UYKKEInquirySource,
      });

      if (wholesaleForm.querySelector('[data-uykke-wholesale-success]')) {
        publish('cannabis_wholesale_submit', {
          page_path: wholesalePath,
          inquiry_source: fields.UYKKEInquirySource,
        });
      }
    }
  }, { once: true });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const articleProducts = link.closest('[data-uykke-article-products]');
    if (articleProducts) {
      const articleTracked = classifyArticleLink(link, articleProducts);
      if (articleTracked) publish(articleTracked.name, articleTracked.data);
    }

    const cannabisPage = event.target.closest('[data-uykke-industry="cannabis-cultivation-processing"]');
    if (!cannabisPage || !cannabisPage.contains(link)) return;
    const tracked = classifyCannabisLink(link);
    if (tracked) publish(tracked.name, tracked.data);
  });
})();
